document.addEventListener("DOMContentLoaded", function () {

  const openBtn = document.getElementById("open-recipe-popup");
  const popup = document.getElementById("recipe-popup");

  if (!popup) return; // important for pages without popup

  const closeBtn = popup.querySelector(".close-popup");
  const overlay = popup.querySelector(".recipe-popup-overlay");
  const addBtn = document.getElementById("add-selected-to-cart");

  if (openBtn) {
    openBtn.addEventListener("click", () => {
      popup.classList.add("active");
    });
  }

  function closePopup() {
    popup.classList.remove("active");
  }

  closeBtn?.addEventListener("click", closePopup);
  overlay?.addEventListener("click", closePopup);

  addBtn?.addEventListener("click", function () {
    const checkboxes = document.querySelectorAll(".recipe-checkbox:checked:not(:disabled)");

    const availableItems = document.querySelectorAll(".recipe-checkbox:not(:disabled)");

if (availableItems.length === 0) {
  document.getElementById("add-selected-to-cart").disabled = true;
}

    let items = [];

    checkboxes.forEach(cb => {
      items.push({
        id: cb.dataset.variantId,
        quantity: 1
      });
    });

    if (items.length === 0) {
      alert("Please select at least one item");
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(res => res.json())
   .then(() => {
  closePopup();

  document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
    bubbles: true
  }));

  setTimeout(() => {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
      bubbles: true
    }));
  }, 200);
})
    .catch(console.error);
  });

});